module.exports = __webpack_public_path__ + "static/media/largebendelclassicbowl14h.0bed68b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Bendel/largebendelclassicbowl14h.jpg
// module id = 5748
// module chunks = 0